"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extension_host_send_crc_and_simulation_frame = exports.addCrcCheckToBuffer = exports.addMessageToBuffer = exports.resetDueToLoad = exports.setCurrentFrame = exports.update = exports.setIsRunning = exports.isPlayerOnCorrectGameSync = exports.updateGameSyncNumberForPlayer = exports.getSyncedImportantRando = exports.getUUnsyncedUnimportantRando = exports.getSyncedUnimportantRando = exports.get2frameIdx = exports.getPartialTick = exports.synced_createId = exports.setMode = exports.getCurrentVisibilityIndex = exports.getIsTickFrame = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var voyageWebsockets_1 = require("@voyage/multi-sockets/voyageWebsockets");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var crokinoleCrc_discs_sidecar_1 = require("@crokinole/multi/crokinoleCrc_discs-sidecar");
var crokinoleCrc_misc_sidecar_1 = require("@crokinole/multi/crokinoleCrc_misc-sidecar");
var crokinole_gameDrift_sidecar_1 = require("@crokinole/multi/crokinole_gameDrift-sidecar");
var crokinole_input_sidecar_1 = require("@crokinole/multi/crokinole_input-sidecar");
var crokinole_simulationFrame_sidecar_1 = require("@crokinole/multi/crokinole_simulationFrame-sidecar");
var physics_rapier_loader_sidecar_1 = require("@crokinole/physics/physics_rapier_loader-sidecar");
var crokinoleDefs_sidecar_1 = require("./crokinoleDefs-sidecar");
var crokinoleSimulationManager_sidecar_1 = require("./crokinoleSimulationManager-sidecar");
var namespace = 'dive-simulation-manager';
var debugSlowSimulationTime = false;
var debugSlowSimulationTimeMultiplier = 10;
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            simulationMode: 'none',
            generator: null,
            gameSyncNumber: 7,
            currentSimuationFrame: 0,
            nextMessageSimulationFrame: 0,
            simulationFrameDelay: 1,
            simulateToFrame: 0,
            frameTimeSeconds: debugSlowSimulationTime
                ? 0.1 * debugSlowSimulationTimeMultiplier
                : 0.1,
            frameTimeAccumulator: 0,
            frameTimeAccumulator_waitingForNextFrame: false,
            isRunning: false,
            isTickFrame: false,
            bufferedCommands: [],
            // afterLevelMessageQueue: [],
            playerGameSyncNumbers: {},
            syncErrorReport: '',
            nextFrameCrc: {
                drift_discs: 0,
                crc_discs: 0,
                crc_misc: 0,
            },
            nextFrameCrcFrame: 0,
            unsyncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(new Date().getTime()),
            syncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(0 + 1),
            syncedImportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(0 + 1 + 1),
            synced_idCounter: 1000,
        };
        resetDueToLoad();
    }
    return _obj;
};
exports.get = get;
function getIsTickFrame() {
    return exports.get().isTickFrame;
}
exports.getIsTickFrame = getIsTickFrame;
function getCurrentVisibilityIndex() {
    return exports.get().currentSimuationFrame;
}
exports.getCurrentVisibilityIndex = getCurrentVisibilityIndex;
function setMode(mode) {
    var obj = exports.get();
    obj.simulationMode = mode;
}
exports.setMode = setMode;
// make sure IDs are the same across clients
function synced_createId(existingId) {
    if (existingId === void 0) { existingId = 0; }
    var obj = exports.get();
    // TODO: check for duplicate ids
    if (existingId) {
        if (existingId > obj.synced_idCounter) {
            obj.synced_idCounter = existingId;
            console.warn('synced_createId', 'existingId is greater than synced_idCounter');
        }
        return existingId;
    }
    obj.synced_idCounter++;
    return obj.synced_idCounter;
}
exports.synced_createId = synced_createId;
// Get fraction of tick for lerping / interpolation
function getPartialTick() {
    var obj = exports.get();
    if (obj.frameTimeAccumulator_waitingForNextFrame) {
        return 1;
    }
    var partialTick = obj.frameTimeAccumulator / (obj.frameTimeSeconds || 0.1);
    partialTick = mathUtils_sidecar_1.mathUtils.clamp1(partialTick);
    // console.log(
    //   namespace,
    //   'getPartialTick',
    //   partialTick,
    //   obj.currentSimuationFrame,
    // )
    return partialTick;
}
exports.getPartialTick = getPartialTick;
// Used for animation bouncing
function get2frameIdx() {
    var obj = exports.get();
    var idx = obj.currentSimuationFrame % 10;
    if (idx >= 5) {
        return 1;
    }
    return 0;
}
exports.get2frameIdx = get2frameIdx;
function getSyncedUnimportantRando() {
    var obj = exports.get();
    return obj.syncedUnimportantRando;
}
exports.getSyncedUnimportantRando = getSyncedUnimportantRando;
function getUUnsyncedUnimportantRando() {
    var obj = exports.get();
    return obj.unsyncedUnimportantRando;
}
exports.getUUnsyncedUnimportantRando = getUUnsyncedUnimportantRando;
function getSyncedImportantRando() {
    var obj = exports.get();
    return obj.syncedImportantRando;
}
exports.getSyncedImportantRando = getSyncedImportantRando;
function updateGameSyncNumberForPlayer(playerId, gameSyncNumber) {
    var obj = exports.get();
    obj.gameSyncNumber = gameSyncNumber;
    console.log(namespace, 'updateGameSyncNumberForPlayer', playerId, gameSyncNumber);
    obj.playerGameSyncNumbers[playerId] = gameSyncNumber;
}
exports.updateGameSyncNumberForPlayer = updateGameSyncNumberForPlayer;
function isPlayerOnCorrectGameSync(playerId) {
    if (playerId === 0) {
        return true; // Hack?
    }
    var obj = exports.get();
    var isInSync = obj.playerGameSyncNumbers[playerId] === obj.gameSyncNumber;
    if (!isInSync) {
        console.log(namespace, 'isPlayerOnCorrectGameSync', playerId, obj.playerGameSyncNumbers[playerId], obj.gameSyncNumber);
    }
    return isInSync;
}
exports.isPlayerOnCorrectGameSync = isPlayerOnCorrectGameSync;
function setIsRunning(isRunning) {
    console.log(namespace, 'setIsRunning', isRunning);
    var obj = exports.get();
    // Reset
    obj.isRunning = isRunning;
    obj.gameSyncNumber++;
    resetDueToLoad();
    //websockets.setSimulationFrame(0)
}
exports.setIsRunning = setIsRunning;
function update() {
    var obj = exports.get();
    var isHost = voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost();
    // console.log(
    //   'simulation',
    //   obj.isRunning,
    //   obj.frameTimeAccumulator,
    //   obj.currentSimuationFrame,
    //   obj.simulateToFrame,
    // )
    if (obj.nextMessageSimulationFrame <= obj.currentSimuationFrame) {
        obj.nextMessageSimulationFrame =
            obj.currentSimuationFrame + obj.simulationFrameDelay;
    }
    // Do we have a running generator?
    // if (diveSimulationManager_generatorManager.hasGenerator()) {
    //   diveSimulationManager_generatorManager.update()
    //   console.log(namespace, 'generating')
    //   obj.frameTimeAccumulator = 0
    //   return
    // }
    // Are we generating?
    if (obj.simulationMode === 'generating') {
        console.log(namespace, 'generating');
        obj.frameTimeAccumulator = 0;
        return;
    }
    if (!obj.isRunning) {
        // console.log(namespace, 'paused')
        obj.frameTimeAccumulator = 0;
        return;
    }
    else {
        // console.log(
        //   namespace,
        //   'running',
        //   obj.currentSimuationFrame,
        //   obj.simulateToFrame,
        //   obj.frameTimeAccumulator,
        // )
    }
    if (obj.simulationMode !== 'game') {
        return;
    }
    // One frame max per frame, catchup
    // obj.simulateToFrame = websockets.getSimulationFrame()
    if (isHost) {
        var delta = common_sidecar_1.common.getUpdateDelta();
        var deltaMax = obj.frameTimeSeconds;
        if (delta > deltaMax) {
            delta = deltaMax;
        }
        obj.frameTimeAccumulator += delta;
        // console.log('update')
        if (obj.frameTimeAccumulator > obj.frameTimeSeconds &&
            obj.currentSimuationFrame === obj.simulateToFrame // Make sure we are caught up
        ) {
            obj.frameTimeAccumulator -= obj.frameTimeSeconds;
            obj.frameTimeAccumulator_waitingForNextFrame = true;
            // Send out message to simulate next frame
            obj.nextMessageSimulationFrame =
                obj.currentSimuationFrame + 1 + obj.simulationFrameDelay;
            extension_host_send_crc_and_simulation_frame();
        }
    }
    else {
        // TODO: get partial frames working for client
        // let delta = common.getUpdateDelta()
        // const deltaMax = obj.frameTimeSeconds
        // if (delta > deltaMax) {
        //   delta = deltaMax
        // }
        // obj.frameTimeAccumulator += delta
        // if (
        //   obj.frameTimeAccumulator > obj.frameTimeSeconds &&
        //   obj.currentSimuationFrame === obj.simulateToFrame // Make sure we are caught up
        // ) {
        //   obj.frameTimeAccumulator -= obj.frameTimeSeconds
        //   obj.frameTimeAccumulator_waitingForNextFrame = true
        // }
    }
    obj.isTickFrame = false;
    if (obj.currentSimuationFrame < obj.simulateToFrame) {
        // console.log(
        //   'updating frame',
        //   obj.currentSimuationFrame,
        //   obj.simulateToFrame,
        // )
        updateFrame();
        updateFrame_processMessages();
    }
}
exports.update = update;
function setCurrentFrame(frame) {
    var obj = exports.get();
    obj.currentSimuationFrame = frame;
    // TODO: add a seed that is unique to the world, for playback? Or have an absolute frame or something? Or an absolute rnd seed?
    obj.syncedUnimportantRando.setCurrentSeed(obj.gameSyncNumber * 10000 + obj.currentSimuationFrame + 1);
    obj.syncedImportantRando.setCurrentSeed(obj.gameSyncNumber * 10000 + obj.currentSimuationFrame + 1 + 17025);
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_gameSync) {
        console.log('synced number', obj.gameSyncNumber, obj.currentSimuationFrame);
    }
}
exports.setCurrentFrame = setCurrentFrame;
function resetDueToLoad() {
    setCurrentFrame(0);
    var obj = exports.get();
    obj.simulateToFrame = 0;
    // websockets.setSimulationFrame(0) // TODO: get rid of this extra complexity?
    // TODO: extension
    obj.nextFrameCrc = {
        drift_discs: 0,
        crc_discs: 0,
        crc_misc: 0,
    };
    obj.nextFrameCrcFrame = 0;
    obj.nextMessageSimulationFrame = 0 + obj.simulationFrameDelay;
    obj.frameTimeAccumulator = 0;
    // Send all of our after load messages
    // let afterLevelMessageQueue = obj.afterLevelMessageQueue
    // afterLevelMessageQueue.forEach((msg) => {
    //   console.log('sending after level message', msg)
    //   diveMessage_alterEntity.sendMessageToAll(msg)
    // })
    // obj.afterLevelMessageQueue = []
    // obj.synced_idCounter =
}
exports.resetDueToLoad = resetDueToLoad;
function updateFrame() {
    var obj = exports.get();
    obj.isTickFrame = true;
    var nextFrame = obj.currentSimuationFrame + 1;
    // Check our CRC at the start of this frame
    if (obj.nextFrameCrcFrame === nextFrame) {
        obj.syncErrorReport = extension_check_crc(nextFrame);
        if (!obj.syncErrorReport) {
            obj.syncErrorReport = 'ok';
        }
    }
    setCurrentFrame(nextFrame);
    // Tick updates
    extension_onFrameTick();
}
function updateFrame_processMessages() {
    var _a, _b;
    var obj = exports.get();
    var commands = obj.bufferedCommands;
    var continueProcessing = true;
    while (continueProcessing && commands.length > 0) {
        var peek = commands[0];
        if (peek.simulationFrame) {
            console.log('SIMULATION FRAME still is being used');
            if (voyageWebsockets_1.getIsHost()) {
                // Host skips crc checks, as they will sometimes already be ahead (?)
                // Not really sure why the host crc is off sometimes, this could cause problems
                var crc = (_a = commands.shift()) === null || _a === void 0 ? void 0 : _a.simulationFrame;
            }
            else {
                var peekCrc = peek.simulationFrame;
                if (peekCrc.frame < obj.currentSimuationFrame) {
                    commands.shift();
                    obj.syncErrorReport = 'OOB';
                    console.error('out of frame bounds, crc out of order', peekCrc, peekCrc.frame, obj.currentSimuationFrame);
                    continue; // Old CRC, ignore
                    // throw new Error('out of frame bounds, crc out of order')
                }
                if (peekCrc.frame > obj.currentSimuationFrame) {
                    // Future frames, process later
                    continueProcessing = false;
                    break;
                }
                // console.log('crc1', 'crew', peek.crc_crew, diveCrew_hero.getCrc())
                // Process this message
                var crc = (_b = commands.shift()) === null || _b === void 0 ? void 0 : _b.simulationFrame;
                assert_sidecar_1.assert.notNil(crc);
                // Check this crc
                // TODO: this is checked elsewhere
                // if (crc.crc_crew) {
                //   let crc_crew = diveCrew_crc.getCrc()
                //   // console.log('crc', 'crew', peek.crc_crew, crc_crew)
                //   if (crc.crc_crew !== crc_crew) {
                //     console.warn('crc mismatch', 'crew', crc.crc_crew, crc_crew)
                //     obj.syncErrorReport = 'crew'
                //   } else {
                //     obj.syncErrorReport = ''
                //   }
                //   // assert.eq(peek.crc_crew, diveCrew_hero.getCrc())
                // }
            }
        }
        if (peek.input) {
            var mi = peek.input;
            if (mi.frame < obj.currentSimuationFrame) {
                commands.shift();
                console.error('out of frame bounds, msg out of order', mi, mi.frame, obj.currentSimuationFrame);
                continue; // Old message, ignore
            }
            if (mi.frame > obj.currentSimuationFrame) {
                // Future frames, process later
                continueProcessing = false;
                break;
            }
            // Process this message
            commands.shift();
            crokinole_input_sidecar_1.crokinole_input.execute(mi);
            // if(mi.hint === ECrokinoleInputHint.PlaceDisc) {
            //   crokinole_input.execute(mi)
            // }
            // // TODO: move processing of mouse input elsewhere
            // if (mi.hint === EDiveInputHint.SelectCrew) {
            //   voyagePicker.nx_setSelection(mi)
            // }
            // if (mi.hint === EDiveInputHint.Move) {
            //   diveCrew_movable.nx_pathTo(mi)
            // }
            // let { isUs, from } = voyageWebsockets.isUsEx(mi.fromMultiId)
            // if (mi.hint === EDiveInputHint.Cast) {
            //   diveSpells.nx_castSpell(mi)
            // }
            // if (mi.hint === EDiveInputHint.Smash) {
            //   diveObjects.nx_smash(mi)
            // }
            // if (mi.hint === EDiveInputHint.Open) {
            //   diveObjects.nx_open(mi)
            // }
            // if (mi.hint === EDiveInputHint.PickUp) {
            //   diveObjects.nx_pickUp(mi)
            // }
            // TODO: affect multiplayer cursors if not us
            // const setAbility = (spell: IDiveSpellDef) => {
            //   if (isUs) {
            //     voyagePicker.setCursorMode('cast')
            //     voyagePicker.get().selectedSpell = spell
            //   } else if (from) {
            //     from.pickMode = 'cast'
            //     from.selectedSpell = spell
            //   }
            // }
            // if (mi.hint === EDiveInputHint.CancelAbility) {
            //   if (isUs) {
            //     diveUi_abilitiesBar.cancelAbility()
            //   } else if (from) {
            //     from.pickMode = 'normal'
            //     from.selectedSpell = null
            //   }
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_basic_useItem) {
            //   diveObjects.nx_use(mi, EDiveEquipSlot.Item)
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_basic_dropItem) {
            //   diveObjects.nx_drop(mi, EDiveEquipSlot.Item)
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_basic_dropLoot) {
            //   diveObjects.nx_drop(mi, EDiveEquipSlot.Loot)
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_basic_dropWeapon) {
            //   diveObjects.nx_drop(mi, EDiveEquipSlot.Weapon)
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_firewall) {
            //   setAbility(diveSpell_firewall)
            // }
            // if (mi.hint === EDiveInputHint.SelectAbility_lightningCloud) {
            //   setAbility(diveSpell_lightningCloud)
            // }
        }
    }
}
function addMessageToBuffer(msg) {
    var obj = exports.get();
    obj.bufferedCommands.push({ input: msg });
}
exports.addMessageToBuffer = addMessageToBuffer;
function addCrcCheckToBuffer(msg) {
    var obj = exports.get();
    obj.nextFrameCrc = {
        drift_discs: msg.drift_discs,
        crc_discs: msg.crc_discs,
        crc_misc: msg.crc_misc,
    };
    obj.nextFrameCrcFrame = msg.frame;
}
exports.addCrcCheckToBuffer = addCrcCheckToBuffer;
// Extensions
function extension_host_send_crc_and_simulation_frame() {
    var drift_discs = 0;
    var crc_discs = 0;
    var crc_misc = 0;
    if (crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().isRunning) {
        drift_discs = crokinoleCrc_discs_sidecar_1.crokinoleCrc_discs.getDrift_discs();
        crc_discs = crokinoleCrc_discs_sidecar_1.crokinoleCrc_discs.getCrc_discs();
        crc_misc = crokinoleCrc_misc_sidecar_1.crokinoleCrc_misc.getCrc_misc();
    }
    var obj = exports.get();
    var msg = {
        frame: obj.currentSimuationFrame + 1,
        gameSyncNumber: obj.gameSyncNumber,
        drift_discs: drift_discs,
        crc_discs: crc_discs,
        crc_misc: crc_misc,
    };
    // console.log(
    //   namespace,
    //   'send simulation frame',
    //   msg.gameSyncNumber,
    //   msg.frame,
    // )
    crokinole_simulationFrame_sidecar_1.crokinole_simulationFrame.sendMessageToAll(msg);
    // DEBUG check drift
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs_extra_drift_checks) {
        var msgDrift = crokinole_gameDrift_sidecar_1.crokinole_gameDrift.createFromState();
        crokinole_gameDrift_sidecar_1.crokinole_gameDrift.sendMessageToAll(msgDrift);
    }
}
exports.extension_host_send_crc_and_simulation_frame = extension_host_send_crc_and_simulation_frame;
function extension_check_crc(nextFrame) {
    var syncErrorReport = '';
    var obj = exports.get();
    var checkCrc = function (crcName, crcA, crcB) {
        if (crcA !== crcB) {
            if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs_report_mismatch) {
                console.warn('crc mismatch', nextFrame, crcName, crcA, crcB);
            }
            if (syncErrorReport) {
                syncErrorReport += ',';
            }
            syncErrorReport += crcName;
        }
    };
    var checkDrift = function (crcName, crcA, crcB) {
        if (crcA !== crcB) {
            if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs_report_mismatch) {
                console.warn('drift mismatch', nextFrame, crcName, crcA, crcB);
            }
            if (syncErrorReport) {
                syncErrorReport += ',';
            }
            syncErrorReport += crcName + '-' + Math.abs(crcA - crcB);
        }
    };
    var crc = obj.nextFrameCrc;
    checkCrc('discs', crc.crc_discs, crokinoleCrc_discs_sidecar_1.crokinoleCrc_discs.getCrc_discs());
    checkCrc('misc', crc.crc_misc, crokinoleCrc_misc_sidecar_1.crokinoleCrc_misc.getCrc_misc());
    checkDrift('drift-discs', crc.drift_discs, crokinoleCrc_discs_sidecar_1.crokinoleCrc_discs.getDrift_discs());
    return syncErrorReport;
}
function extension_onFrameTick() {
    physics_rapier_loader_sidecar_1.physics_rapier_loader.updatePhysics_networked(1);
    // crokinole
    // diveCalcHeroVisibility.calcHeroVisibility_updateTick()
    // diveObjects.updateTickAll()
    // diveCrew.updateTickAll()
    // diveBullets.updateTickAll()
    // diveSpells.updateTickAll()
    // // console.log('???')
    // diveSimulationDirector.updateTick()
    // TODO: what to update for crokinole?
}
